import React, { FC, useEffect, useState } from 'react';
import styled from 'styles/styled-components';
import media from 'utils/mediaStyle';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';
import { Modal as AModal } from 'antd';
import ShortContactForm from './ShortContactForm';
import contactMessages from 'containers/ContactUsPage/messages';
import { commonDimensions } from 'utils/constants';

const FormWrapper = styled.div`
  padding: 16px;
  width: 100%;
  background: #ffffff;
  border-radius: 16px;
  ${media.sm`
    padding: 24px 40px;
    `}
`;

const FormTitle = styled.p`
  display: flex;
  justify-content: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  color: #242527;
  ${media.md`
    font-size: 28px;
    font-weight: 600;
    line-height: 36px;
    `}
`;

const Modal = styled(AModal)`
  background: unset;
  .ant-modal-content {
    background: transparent;
    box-shadow: unset;
    padding: 0;
    max-width: ${commonDimensions.MAX_WIDTH_CONTAINER}px;
    width: 100%;
    margin: 0 auto;
    .ant-modal-close {
      right: 12;
      top: 12px !important;
      border-radius: 50% !important;
      &: hover {
        background: #f6f6f6 !important;
      }
    }
    .ant-modal-body {
      border-radius: 8px;
      overflow: hidden;
      img {
        border-radius: 8px;
      }
    }
    ${media.md`
      max-width: 1000px;
      `}
  }
`;

const BusinessNoticeParahraph = styled.div`
  color: #9e9e9e;
  margin-bottom: 12px;
  text-align: center;
`;

const LandingPageAnchor = styled.a`
  color: #42a5f5;
`;

const ContactUsModal: FC<{ isOpen: boolean; onCloseContactModal: () => void }> = ({ isOpen, onCloseContactModal }) => {
  const [visible, setVisible] = useState(false);
  const lang = localStorage.getItem('lang') || 'vi';

  useEffect(() => {
    if (isOpen) {
      setVisible(true);
    }
  }, [isOpen]);

  return (
    <Modal
      open={visible}
      footer={null}
      onCancel={() => {
        setVisible(false);
        onCloseContactModal();
      }}
      centered
      width={525}
      bodyStyle={{ padding: 0, textAlign: 'center' }}
    >
      <FormWrapper>
        <ShortContactForm
          header={
            <>
              <FormTitle>
                <FormattedMessage {...messages.contactUs} />
              </FormTitle>
              <BusinessNoticeParahraph>
                <FormattedMessage {...contactMessages.businessNotice} />{' '}
                <LandingPageAnchor
                  target="_Blank"
                  rel="noopener noreferrer"
                  href={`https://kamereo.vn/${lang === 'vi' ? 've-kamereo' : 'about-kamereo'}`}
                >
                  <FormattedMessage {...contactMessages.findOutAboutTheService} />
                </LandingPageAnchor>
              </BusinessNoticeParahraph>
            </>
          }
          onSuccess={() => {
            setVisible(false);
            onCloseContactModal();
          }}
          destroyForm={!visible}
        />
      </FormWrapper>
    </Modal>
  );
};

export default ContactUsModal;
